import styled from "styled-components";

export const CodesConatiner = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
  @media (max-width: 64em) {
    display: none;
  }
`;
